<template>
  <v-dialog :value="messageBox" width="400px" persistent>
    <v-card>
      <v-card-text class="text-center pt-6">
        <v-icon size="64" :color="iconColor">{{ messageIcon }}</v-icon>
      </v-card-text>
      <v-card-text class="text-center">{{ messageBoxMessage }}</v-card-text>
      <v-card-text class="text-center pt-5 pb-8">
        <v-btn
          v-if="messageBoxType != 'confirm'"
          color="primary"
          @click="onClick('success')"
          >{{ close }}</v-btn
        >
        <v-btn
          v-if="messageBoxType == 'confirm'"
          color="primary"
          class="mr-2"
          @click="onClick('success')"
          >{{ ok }}</v-btn
        >
        <v-btn
          v-if="messageBoxType == 'confirm'"
          color="error"
          outlined
          @click="onClick('cancel')"
          >{{ cancel }}</v-btn
        >
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
  
  <script>
import { useLocalStore } from "@/store/local";
import { mapState, mapActions } from "pinia";
import { useAppStore } from "@/store/app";

export default {
  computed: {
    iconColor() {
      if (this.messageBoxType == "error") {
        return "error";
      } else if (this.messageBoxType == "success") {
        return "success";
      }

      return "info";
    },
    messageIcon() {
      if (this.messageBoxType == "error") return "mdi-alert-circle";
      else if (this.messageBoxType == "confirm")
        return "mdi-help-circle-outline";
      else if (this.messageBoxType == "success")
        return "mdi-check-circle-outline";
      return "mdi-information-outline";
    },

    ...mapState(useLocalStore, ["cancel", "close", "ok"]),
    ...mapState(useAppStore, [
      "messageBoxSuccess",
      "messageBoxCancel",
      "messageBoxMessage",
      "messageBoxType",
      'messageBox'
    ]),
  },

  methods: {
    onClick(v) {
      if (v == "success") {
        if (typeof this.messageBoxSuccess == "function")
          this.messageBoxSuccess();
      } else {
        if (typeof this.messageBoxCancel == "function")
          this.messageBoxCancel();
      }

      this.hideMessageBox();
    },

    ...mapActions(useAppStore, ["hideMessageBox"]),
  },
};
</script>